import { createContext, useContext, useState, useCallback } from "react";
import FIL from "./i18n_fil";

const D = {
  app_sub: ["GKK & Unit Financial Management Information System", "Sistema sa Pagdumala sa Pinansyal sa GKK ug Unit"],
  record_collection: ["Record Collection", "I-rekord ang Kolekta"],
  record_expense: ["Record Expense", "I-rekord ang Gasto"],
  view_report: ["View Financial Report", "Tan-awon ang Report sa Kuwarta"],
  special_collections: ["Special Collections", "Espesyal nga Kolekta"],
  remittances: ["Remittances", "Remit / Pagpasa sa Kuwarta"],
  monthly_dues: ["Monthly Dues", "Binulan nga Hulog"],
  dashboard: ["Financial Dashboard", "Dashboard sa Pinansyal"],
  download_reports: ["Download Reports", "I-download ang Report"],
  request_correction: ["Request Correction", "Hangyo sa Pagtul-id"],
  admin_panel: ["Administrative Panel", "Panel sa Administrador"],
  search: ["Search Records", "Pangitaa ang Rekord"],
  unit_roster: ["Unit Treasurers List", "Listahan sa mga Tesorero sa Unit"],
  my_reports: ["My Collection Reports", "Akong mga Report sa Kolekta"],
  login: ["Sign in", "Sulod"],
  username: ["Username", "Username"],
  password: ["Password", "Password"],
  logout: ["Sign out", "Gawas"],
  home: ["Home", "Panid"],
  save_draft: ["Save Draft", "I-save ang Draft"],
  review_entry: ["Review Entry", "Susiha ang Rekord"],
  submit_final: ["Submit Final Report", "Isumite ang Final nga Report"],
  where_when: ["Where & when", "Asa ug kanus-a"],
  amounts: ["Amounts collected", "Kantidad nga nakolekta"],
  people_cert: ["Counting & certification", "Pag-ihap ug sertipikasyon"],
  gkk: ["GKK", "GKK"],
  unit: ["Unit", "Unit"],
  gkk_level: ["GKK-level (not a Unit)", "GKK mismo (dili Unit)"],
  report_type: ["What happened?", "Unsay nahitabo?"],
  rt_collection: ["Collection was made", "Adunay kolekta"],
  rt_no_collection: ["No collection", "Walay kolekta"],
  rt_service_canceled: ["Service canceled", "Wala nadayon ang serbisyo"],
  occasion: ["Type of activity", "Matang sa kalihokan"],
  date_collection: ["Date of collection", "Petsa sa kolekta"],
  start_time: ["Start time", "Oras sa pagsugod"],
  end_time: ["End time", "Oras sa paghuman"],
  counted_at: ["Time money was counted", "Oras sa pag-ihap sa kuwarta"],
  location: ["Location / Purok", "Lugar / Purok"],
  venue: ["Venue (chapel, house, etc.)", "Dapit (kapilya, balay, ubp.)"],
  add_line: ["Add another collection", "Dugang kolekta"],
  category: ["Collection category", "Klase sa kolekta"],
  amount: ["Amount (₱)", "Kantidad (₱)"],
  total: ["Total", "Kinatibuk-an"],
  denom_counter: ["Count bills & coins (optional)", "Ihap sa bilhete ug sensilyo (opsyonal)"],
  declared_total: ["Total you counted by hand (optional)", "Kinatibuk-an nga imong giihap (opsyonal)"],
  treasurer_name: ["Name of Treasurer / Collector", "Ngalan sa Tesorero / Kolektor"],
  position: ["Position", "Posisyon"],
  witness: ["Second counter / witness", "Ikaduhang nag-ihap / saksi"],
  custodian: ["Person keeping the money (if different)", "Tigtipig sa kuwarta (kon lahi)"],
  certify: ["I certify that the collection and financial information entered in this report has been personally counted or verified by me and is true, complete, and accurate to the best of my knowledge.",
    "Akong gipamatud-an nga ang kolekta ug impormasyon sa pinansyal niining report personal nakong giihap o gisusi ug tinuod, kompleto, ug husto sumala sa akong kahibalo."],
  review_warning: ["Please review all amounts and details carefully. Once submitted, this report will be locked. Any subsequent correction will require the approval of the Parish Administrator.",
    "Palihug susiha pag-ayo ang tanang kantidad ug detalye. Kon isumite na, ma-lock kini nga report. Ang bisan unsang pagtul-id kinahanglan aprobahan sa Administrador sa Parokya."],
  back_edit: ["Go back and edit", "Balik ug usba"],
  confirm_submit: ["Yes, submit and lock", "Oo, isumite ug i-lock"],
  offline_banner: ["You are offline. You can save drafts on this phone; they will upload when internet returns. Offline drafts are NOT official submissions.",
    "Wala kay internet. Pwede ka mag-save og draft niining telepono; i-upload kini inig balik sa internet. Ang offline nga draft DILI pa opisyal nga submission."],
  saved_locally: ["Saved on this phone only", "Na-save sa telepono lang"],
  status_draft: ["Draft", "Draft"],
  status_submitted: ["Submitted", "Naisumite"],
  status_pending_verification: ["Under Verification", "Gisusi Pa"],
  status_verified: ["Verified", "Beripikado"],
  status_rejected: ["Returned for Correction", "Gibalik aron Tul-iron"],
  status_finalized: ["Finalized", "Final na"],
  status_approved: ["Approved", "Naaprobahan"],
  status_paid: ["Paid", "Nabayran"],
  status_cancelled: ["Cancelled", "Gikansela"],
  status_pending: ["Pending", "Naghulat"],
  status_info_requested: ["More Info Requested", "Nangayo og Dugang Info"],
  status_reported: ["Reported", "Nareport Na"],
  status_no_collection: ["No Collection", "Walay Kolekta"],
  status_service_canceled: ["Service Canceled", "Wala Nadayon"],
  status_not_yet_reported: ["Not Yet Reported", "Wala Pa Nareport"],
  regular: ["Regular", "Regular"],
  special: ["Special (designated)", "Espesyal (designated)"],
  other: ["Other receipts", "Ubang nadawat"],
  not_yet_reported: ["Not yet reported", "Wala pa nareport"],
  notifications: ["Notifications", "Mga Pahibalo"],
  mark_all_read: ["Mark all as read", "Markahi nga nabasa"],
  public_page: ["Public transparency summary", "Publikong katingbanan"],
  welcome: ["Welcome to the GKK Financial Management Information System. This platform provides authorized GKK and Unit officers with a secure means of recording, reviewing, verifying, and monitoring financial collections, remittances, expenses, and related financial transactions.",
    "Maayong pag-abot sa GKK Financial Management Information System. Kini nga plataporma naghatag sa mga awtorisadong opisyal sa GKK ug Unit og luwas nga paagi sa pagrekord, pagrepaso, pagpamatuod, ug pagmonitor sa mga kolekta, remittance, gasto, ug uban pang transaksyon sa pinansyal."],
  notice_only: ["Only officially recognized GKK and Unit officers may register for administrative or financial management access. All registrations are subject to verification and approval by the Parish Administrator.",
    "Ang opisyal nga giila nga mga opisyal sa GKK ug Unit lamang ang makarehistro alang sa administratibo o pinansyal nga access. Ang tanang rehistro susihon ug aprobahan sa Administrador sa Parokya."],
  google_btn: ["Sign in with Google", "Sulod gamit ang Google"],
  email_login: ["Log in with Email and Password", "Sulod gamit ang Email ug Password"],
  register_btn: ["Register as GKK/Unit Officer", "Magparehistro isip Opisyal sa GKK/Unit"],
  forgot: ["Forgot Password?", "Nakalimtan ang Password?"],
  check_status: ["Check Registration Status", "Susiha ang Status sa Rehistro"],
  contact_admin: ["Contact Parish Administrator", "Kontaka ang Administrador sa Parokya"],
  email: ["Registered email address", "Narehistro nga email address"],
  remember_email: ["Remember email", "Hinumdumi ang email"],
  show: ["Show", "Ipakita"],
  hide: ["Hide", "Tagoa"],
  announcements: ["Announcements", "Mga Pahibalo"],
};

const Ctx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("fmis_lang") || "en");
  const toggle = useCallback(() => {
    setLang((l) => {
      const n = l === "en" ? "ceb" : l === "ceb" ? "fil" : "en";
      localStorage.setItem("fmis_lang", n);
      return n;
    });
  }, []);
  const t = useCallback((k) => (lang === "fil" ? FIL[k] || (D[k] ? D[k][0] : k) : D[k] ? D[k][lang === "en" ? 0 : 1] : k), [lang]);
  const nextLabel = lang === "en" ? "Cebuano" : lang === "ceb" ? "Filipino" : "English";
  return <Ctx.Provider value={{ lang, toggle, t, nextLabel }}>{children}</Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
